// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2V9MN","footer":"ModalCreateQualiphyProcedure_footer__2R7ZB","additionData":"ModalCreateQualiphyProcedure_additionData__3PgvC"};